module.exports = __webpack_public_path__ + "static/img/aiAbility-img.b48d150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeatures/aiAbility-img.png
// module id = ao0E
// module chunks = 0